const basePath = '/el-drop/3d/icons';

export default {
    checkout: `${basePath}/checkout.png`,
    payment: `${basePath}/payment.png`,
    shipping: `${basePath}/shipping.png`,
    billing: `${basePath}/billing.png`,
}